import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import { SearchComponent } from 'components';

const styles = () => ({
  button: {
    backgroundColor: '#00c308',
    borderRadius: 5,
    marginBottom: 5,
    marginRight: 15,
  },
  buttonLabel: {
    color: '#fff',
    fontWeight: 600,
  },
});

const Search = ({
  cancelSearch,
  placeholder,
  onChange,
  searchText,
}) => (
  <div
    className="search-bar"
  >
    <SearchComponent
      cancelSearch={cancelSearch}
      placeholder={placeholder}
      search={onChange}
      searchText={searchText}
    />
  </div>
);

Search.propTypes = {
  placeholder: PropTypes.string,
  searchText: PropTypes.string,

  cancelSearch: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
};

Search.defaultProps = {
  placeholder: '',
  searchText: '',
};

export default withStyles(styles)(Search);
